enum DeliveryStatus {
    PENDING = "pending",
    PICKING = "picking",
    IN_DELIVERY = "in_delivery",
    COMPLETED = "completed",
    CANCELLED = "cancelled"
}
export default DeliveryStatus;